/*
 * The old Oi Polloi theme's article behaviour, ported from frost/oi-polloi-theme-old/assets/theme.js.
 *
 * Every image in an article body is wrapped in an img__wrap box named for its shape, which
 * article-classic.css uses to let wide images break further out of the text column than tall ones.
 * YouTube and Vimeo embeds keep the aspect ratio of their width/height attributes at any width.
 */
(() => {
  const shapeOf = (ratio) => {
    if (ratio > 1.25) return 'landscape';
    if (ratio < 0.85) return 'portrait';
    return ratio === 1 ? 'square' : 'squarish';
  };

  const wrapImage = (img) => {
    if (img.closest('.img__wrap') || !img.naturalWidth || !img.naturalHeight) return;

    const wrap = document.createElement('div');
    wrap.className = `img__wrap img__wrap--${shapeOf(img.naturalWidth / img.naturalHeight)}`;
    img.before(wrap);
    wrap.append(img);
  };

  const sizeVideo = (iframe) => {
    const width = parseFloat(iframe.getAttribute('width'));
    const height = parseFloat(iframe.getAttribute('height'));
    if (!width || !height) return;

    iframe.style.aspectRatio = `${width} / ${height}`;
    iframe.style.width = '100%';
    iframe.style.height = 'auto';
  };

  const init = (root = document) => {
    root.querySelectorAll('.op-article .rte img').forEach((img) => {
      if (img.complete) {
        wrapImage(img);
      } else {
        img.addEventListener('load', () => wrapImage(img), { once: true });
      }
    });

    root
      .querySelectorAll(".op-article .rte :is(iframe[src*='player.vimeo.com'], iframe[src*='youtube.com'])")
      .forEach(sizeVideo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
